import { observer } from "mobx-react-lite";

import type { SettingsPage } from "../../stores/NavigationStore";
import { useStores } from "../../stores/useStores";
import { List, PaneHeader, PaneTitle, Row, RowDetail, RowText, RowTitle } from "../ui/lists";

/** The pages of the settings, with what's on each. */
const PAGES: { page: SettingsPage; title: string; detail: string }[] = [
    { page: "appearance", title: "Appearance", detail: "Theme, colours, text size, spacing and font" },
    { page: "general", title: "General", detail: "Your account, and how the app behaves" },
];

/** The settings: how the app looks is kept apart from how it behaves. */
export const SettingsList = observer(function SettingsList({ page }: { page?: SettingsPage }) {
    const { navigation } = useStores();

    return (
        <>
            <PaneHeader>
                <PaneTitle>Settings</PaneTitle>
            </PaneHeader>
            <List>
                {PAGES.map((item) => (
                    <li key={item.page}>
                        <Row aria-current={item.page === page} onClick={() => navigation.go({ name: "settings", page: item.page })}>
                            <RowText>
                                <RowTitle>{item.title}</RowTitle>
                                <RowDetail>{item.detail}</RowDetail>
                            </RowText>
                        </Row>
                    </li>
                ))}
            </List>
        </>
    );
});
